import dayjs from 'dayjs';

export function convertLocalToUTC(date: string, startTime: string) {
  const localDateTime = new Date(dayjs(date).format('YYYY-MM-DD') + 'T' + startTime);
  const utcDateTime = localDateTime.toISOString();

  return utcDateTime;
}
